export const urls = {
  GET_DELOVI_ZA_ID: 'Delovi/vrati_delove_za_masinu',
  INSERT_DELOVI: 'Delovi/unos_delova',
  UPDATE_DELOVI: 'Delovi/izmena_delova',
  DELETE_DELOVI: 'Delovi/brisanje_dela',
  INSERT_EXCEL_DELOVI: 'Delovi/unos_delova_iz_excel_fajla',
  GET_SLIKE_ZA_DEO: 'Dokumenta/konvertovanje_base64_sa_id',
  VRATI_KATEGORIJU_DELOVA: 'Combo/vrati_kategorije_delova',
};
